subscription PurchaseOrderDocumentPackageStatus($id: UUID!) {
  purchaseOrderDocumentPackageStatus(id: $id) {
    document {
      id
    }
    status
  }
}
